const collator = new Intl.Collator("pt-BR", { sensitivity: "base", numeric: true });

export const normalizeName = (value: string) =>
  value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase("pt-BR").trim();

export function filterByName<T>(items: readonly T[], query: string, getName: (item: T) => string): T[] {
  const terms = normalizeName(query).split(/\s+/).filter(Boolean);
  return items.filter((item) => terms.every((term) => normalizeName(getName(item)).includes(term)));
}

export function searchByName<T>(items: readonly T[], query: string, getName: (item: T) => string): T[] {
  return filterByName(items, query, getName).sort((a, b) => collator.compare(getName(a), getName(b)));
}
